export const MOBILE_APP_1_CONSTANTS = {
  DEFAULT_ROW: {},

  MOBILE_APP_FIELDS_CONFIG: [
    {
      fieldName: "desktop_bg_image",
      label: "Desktop Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Mobile Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Alt Image Text",
      value: "Mobile App Preview",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
      required: false,
      defaultValue: "Mobile App Preview",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Download Our Mobile App",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "Download Our Mobile App",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "video_link",
      label: "Video Link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Video Link",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "google_play_icon",
      label: "Google Play Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Google Play Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "google_play_icon_alt",
      label: "Google Play Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for Google Play icon",
      required: false,
      defaultValue: "Get it on Google Play",
    },
    {
      fieldName: "google_play_link",
      label: "Google Play Link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Google Play Store Link",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "app_store_icon",
      label: "App Store Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload App Store Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "app_store_icon_alt",
      label: "App Store Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for App Store icon",
      required: false,
      defaultValue: "Download on the App Store",
    },
    {
      fieldName: "app_store_link",
      label: "App Store Link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter App Store Link",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter section background color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "is_blog",
      label: "Blog",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Use blog column layout (left-aligned title and content)",
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Mobile App Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Mobile App Status",
      defaultValue: false,
    }
  ],
};

